import { User } from "./user.model";

export class UserResult {
  user: User;
  token: string;
}
